class StoreSelectorPopup extends HTMLElement {
  locations = [];
  #queryHasError = false;
  constructor() {
    super();

    this._init();
    this._getStores();
    document.querySelectorAll(".js-open-stores-popup").forEach((opener) => {
      opener.addEventListener("click", () => {
        this.open();
      });
    });
    this._initClosers();
  }
  async _init() {
    const localStorageValue = localStorage.getItem("selectedStore");
    if (!localStorageValue) {
      await this._getStores();
      if (this.#queryHasError === false) {
        this.open();
      }
    }
  }
  async _getStores() {
    try {
      const productId = this.dataset.productId ? `?productId=${this.dataset.productId}` : ''

      const response = await fetch(`https://organica-apps-c23e09019143f9e3995d.o2.myshopify.dev/query-locations${productId}`);
      const data = await response.json();
      console.log("DATA: ", data);
      this.locations = data.locations;
      this._renderLocations();
      this._addButtonEvents();
    } catch (error) {
      this.#queryHasError = true;
      console.error("Error! ", error);
    }
  }

  _renderLocations() {
    // Get the template and the container for the items.
    const template = this.querySelector("template#store-item");
    const container = this.querySelector(".ssp__items");

    // Clear container in case it has previous content.
    container.innerHTML = "";

    // Loop through the locations and populate the template.
    this.locations.forEach((location) => {
      // Clone the template content.
      const clone = document.importNode(template.content, true);
      // Update text content for each element with the location data.
      clone.querySelector(".ssp__store-item--name").textContent = location.name;
      // clone.querySelector(".ssp__store-item--address").textContent =
      //   location.address;
      // clone.querySelector(".ssp__store-item--province").textContent =
      //   location.provinceCode;
      clone.querySelector(".ssp__store-item--id").value = location.id;

      if (this.dataset.isPdp == 'true'){
        if (!location.productQty || location.productQty < 1){
          clone.querySelector(".ssp__store-item--availability").classList.add("store-out-of-stock")
        }
        clone.querySelector(".ssp__store-item--availability").textContent = (location.productQty || 0) + ' disponibles'
        
      }

      // Optionally, you can conditionally show/hide the pickup icon.
      if (!location.isPickupAvailable) {
        clone.querySelector(".ssp__pickup-available").style.display = "none";
      }

      // Append the clone into the container.
      container.appendChild(clone);
    });
  }

  _addButtonEvents() {
    this.querySelectorAll(".ssp__store-item-btn").forEach((button) => {
      button.addEventListener("click", () => {
        this.oldStore = localStorage.getItem("selectedStore") || null;
        localStorage.setItem(
          "selectedStore",
          button
            .closest(".ssp__store-item")
            .querySelector(".ssp__store-item--id").value
        );
        this.storeId = localStorage.getItem("selectedStore") || null;
        this.close();
        this.dispatchStoreChangedEvent();
      });
    });
  }

  dispatchStoreChangedEvent() {
    window.dispatchEvent(
      new CustomEvent("storeSelected", {
        detail: {
          storeId: this.storeId,
          oldStoreId: this.oldStore,
        },
      })
    );
  }

  open() {
    this.classList.add("open");
  }
  close() {
    this.classList.remove("open");
    if (!localStorage.getItem("selectedStore")){
      console.log("Default location")
      localStorage.setItem("selectedStore", this.locations[0].id)
      this.dispatchStoreChangedEvent();
    }
     
  }
  _initClosers() {
    this.querySelectorAll(".overlay, .ssp__close-btn").forEach(closer => {
      closer.addEventListener("click", () => {
        this.close()
      })
    })
  }
}

customElements.define("store-selector-popup", StoreSelectorPopup);

class StoreLocationStatus extends HTMLElement {
  constructor() {
    super();
    this.availableLocations = this.dataset.availableLocations; //returns a string divided by ";"
    this.localStorageValue = localStorage.getItem("selectedStore");
    this.isInStockContent = this.querySelector(".sls__is-in-stock-content");
    this.outOfStockContent = this.querySelector(
      ".sls__out-of-stock-icon-content"
    );
    this.atcBtn = document.querySelector(".product-form__submit.button")
    this.productId = this.dataset.productId;
    this.locationsQtys = this.querySelectorAll(".sls__stock-count");

    if (this.localStorageValue) {
      this.checkLocationStatus();
    }
    window.addEventListener("storeSelected", () => {
      this.localStorageValue = localStorage.getItem("selectedStore");
      this.checkLocationStatus();
    })
    
  }
  checkLocationStatus() {
    if (!this.availableLocations.includes(this.localStorageValue)) {
      this.setStatus({ available: false });
      this.atcBtn?.setAttribute("disabled", "true")
      return;
    }
    this._sendRequest();
  }

  setStatus(data) {
    this.setLocationNames();
    if (data.available === false) {
      this.isInStockContent.classList.add("hidden");
      this.outOfStockContent.classList.remove("hidden");
    }

    if (data.available === true) {
      this.isInStockContent.classList.remove("hidden");
      this.outOfStockContent.classList.add("hidden");
    }

    this.show();
  }
  setLocationNames(name = null) {
    const storeName = STORES_DATA.store_data.find(
      (store) => Number(store.id) === Number(this.localStorageValue)
    )?.store_name;
    if (!storeName){
      return;
    }
    if (name === null) {
      name = storeName;
    }
    if (!name) {
      return;
    }
    this.querySelectorAll(".sls__stock-location").forEach((el) => {
      el.textContent = name;
    });
  }
  async _sendRequest() {
    try {
      const formData = new FormData();
      formData.append("locationId", this.localStorageValue);
      formData.append("productId", this.productId);
      const config = {
        method: "POST",
        body: formData,
      };

      
      const response = await fetch(
        `https://organica-apps-c23e09019143f9e3995d.o2.myshopify.dev/location-quantity`,
        config
      );
      const data = await response.json();
      if (data.ok) {

        this.locationsQtys.forEach(
          (qtyItem) => {
            console.log("qtyItem, ", qtyItem, data)
            qtyItem.textContent = data.quantity
            if (Number(data.quantity) < 1 ) {
              this.atcBtn?.setAttribute("disabled", "true")
            } else {
              this.atcBtn?.removeAttribute("disabled")
            }
          });
        this.setStatus({ available: true });
        this.setMaxQty(data.quantity);
        return;
      }

      
      console.log(data);
    } catch (error) {
      console.error(error);
      console.error("Something went wrong, plase reload");
    }
  }
  setMaxQty(qty) {
    this.closest(".product__info-wrapper ")?.querySelector("product-form")?.setAttribute("data-max-qty", qty)
  }
  show() {
    this.classList.remove("hidden");
  }
  hide() {
    this.classList.add("hidden");
  }
}

customElements.define("store-location-status", StoreLocationStatus);
